import { getSemestreFromDate, getTrimestreFromDate } from '../novo-datepicker.utils';

/**
 * Verifica se a data selecionada cai no mês/ano informado.
 *
 * Retorna false quando não há valor — usada pelo template para destacar a
 * célula do mês selecionado no painel mensal sem precisar de null-checks.
 */
export function monthMatches(value: Date | null, month: number, year: number): boolean {
  if (!value) {
 return false;
}
  return value.getFullYear() === year && value.getMonth() + 1 === month;
}

/**
 * Verifica se a data selecionada cai no trimestre/ano informado.
 *
 * O trimestre é derivado do mês via getTrimestreFromDate (1..4) — mesma
 * regra usada pelo handler de seleção, garantindo simetria entre destaque
 * visual e estado armazenado.
 */
export function quarterMatches(value: Date | null, quarter: number, year: number): boolean {
  if (!value) {
 return false;
}
  return value.getFullYear() === year && getTrimestreFromDate(value) === quarter;
}

/**
 * Verifica se a data selecionada cai no semestre/ano informado.
 *
 * O semestre é derivado do mês via getSemestreFromDate (1 ou 2) — mesma
 * regra usada pelo handler de seleção, garantindo simetria entre destaque
 * visual e estado armazenado.
 */
export function semesterMatches(value: Date | null, semester: number, year: number): boolean {
  if (!value) {
 return false;
}
  return value.getFullYear() === year && getSemestreFromDate(value) === semester;
}

/**
 * Verifica se a data selecionada cai no ano informado.
 */
export function yearMatches(value: Date | null, year: number): boolean {
  if (!value) {
 return false;
}
  return value.getFullYear() === year;
}
